import about from "../assets/about.webp";

export default function About() {
  return (
    <div className="mission-container">

      {/* ELIGIBILITY SECTION */}
      <div className="eligibility-section">

        <div className="eligibility-text">
             <h2>Our Mission</h2>

          <p>
            The <strong>Seeds of a Watermelon Scholarship Fund</strong> is dedicated 
            to empowering displaced Gazan students to achieve their academic dreams 
            and build brighter futures.
          </p>

          <p>
            By providing holistic financial support—including tuition, living 
            expenses, and resources for personal and professional growth—we ensure 
            that opportunity is not limited by circumstance.
          </p>

          <p>
            With <strong>zero administrative costs</strong> (except transfer fees), 
            every contribution directly transforms lives, fostering a generation of 
            empowered leaders who will inspire and uplift their communities.
          </p>
          <h2>Eligibility Criteria</h2>

          <p>Applicants must:</p>

          <ul>
            <li>Be of Gazan origin and hold refugee or displaced status.</li>
            <li>Demonstrate financial need.</li>
            <li>Show evidence of academic potential or achievement.</li>
          </ul>

          <p>
            Open to students pursuing any degree in any country, with preference 
            given to those lacking other financial resources for higher education.
          </p>

          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSekeW9yhsT7H-9zRTXYjvsIXCbWu0qOotxpxeYbmRiWKhuLkw/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="mission-apply-btn"
          >
            APPLY HERE
          </a>
        </div>

        {/* IMAGE ON THE RIGHT */}
        <img src={about} alt="about" className="about" />

      </div>

    </div>
  );
}